import {  getFirestore, where, writeBatch } from 'firebase/firestore';
import 'firebase/functions'
import {
    getQueryBusinessPortalAccessCollection,
    getUsersDoc,
    updateUserDoc,
    usersDocRef,
    getAuth
} from "@/shared/firebase_utils";

const state = {
    userProfile: {
        firstName: ' ',
        lastName: ' ',
        businessProfileId: '',
    },
    loggedInUsersUid: '',
    loggedInUsersPermissions: [],
 
};

const getters = {
    userProfile: (state) => state.userProfile,
    loggedInUsersUid: (state) => state.loggedInUsersUid,
    loggedInUsersPermissions: (state) => state.loggedInUsersPermissions,
    currentPermission: (state) => {
        let i = 0;
        for(i = 0; i <= state.loggedInUsersPermissions.length; i++) {
            if(state.loggedInUsersPermissions[i].businessProfileId == state.userProfile.businessProfileId) {
                return state.loggedInUsersPermissions[i];
            }
        }
        return undefined;
    },
    isSuperUser:  (state) => { return state.userProfile.email == 'son@pappyon.com' || state.userProfile.email == 'yash@pappyon.com'},
};

const actions = {
    async initializeUserProfile({ commit, dispatch }, uid) {
        try {

            //Read data from firestore
            let docRef = await getUsersDoc(uid);
            //Set the uid and the user profile in the state
            commit('setLoggedInUsersUid', uid);
            commit('setUserProfile', docRef.data());
            //Set the users permissions in the state
            await dispatch('initializeUserPermissions', uid);
            //Initialize the business profile module
            await dispatch('initializeBusinessProfileModule');
        }
        catch(error) {
            console.log("Error getting documents: ", error);
        };
    },
    async initializeUserPermissions({ commit }, uid) {
        try{
            let response = await getQueryBusinessPortalAccessCollection(where('uid', '==', uid),where('status', '==', 'active'));
            let permissions = response.docs.map((doc) => {
                return { documentId: doc.id, ...doc.data() };
            });
            commit('setUsersPermissions', permissions);
        } catch(error) {
            console.log(error);
        }; 
    },

    async initializeBusinessProfileModule({ commit, dispatch }) {
        let businessProfileId = state.userProfile.businessProfileId || '';
        let i = 0;
        if(businessProfileId != '') {
            for(i=0; i< state.loggedInUsersPermissions.length; i++) {
                if (state.loggedInUsersPermissions[i].businessProfileId == businessProfileId) {
                    //Initilaize the business profile and business card associated with this businessProfileId
                    await dispatch('initializeBusinessProfile', businessProfileId, { root: true });
                }
            }  
        }
    },

    async updateUserProfileDetails({ rootState, dispatch, commit }, updatedUserProfile) {
        try {
            //Get a reference to firestore
            const db = getFirestore();
            const uid = getAuth().currentUser.uid;

            let batch = writeBatch(db);
            const documentRef = usersDocRef(uid);
            //Update the user profile in firebase
            batch.update(documentRef, updatedUserProfile);

            //Start: If the user's name has changed then update the user's business profile permissions
            const updatedFirstName = updatedUserProfile.firstName ?? state.userProfile.firstName;
            const updatedLastName = updatedUserProfile.lastName ?? state.userProfile.lastName;
            const isFirstNameUpdated = updatedFirstName != state.userProfile.firstName;
            const isLastNameUpdated = updatedLastName != state.userProfile.LastName;
            if (isFirstNameUpdated || isLastNameUpdated) {
                let usersPermissions = await getQueryBusinessPortalAccessCollection(where('uid', '==', uid));
                usersPermissions.forEach((documentSnapshot) => {
                    batch.update(documentSnapshot.ref, { firstName: updatedUserProfile.firstName, lastName: updatedUserProfile.lastName });
                });
            }
            //End: If the user's name has changed then update the user's business profile permissions

            //Start: If the user's email has changed then call a cloud function to update the user's email
            const updatedEmail = updatedUserProfile.email ?? state.userProfile.email;
            const isEmailUpdated = updatedEmail != state.userProfile.email;
            if (isEmailUpdated) {
                let usersPermissions = await getQueryBusinessPortalAccessCollection(where('uid', '==', uid));

                usersPermissions.forEach((documentSnapshot) => {
                    batch.update(documentSnapshot.ref, {
                        email:  updatedEmail,
                    });
                });
            }
            //End: If the user's email has changed then call a cloud function to update the user's email
            await batch.commit();

            //Read data from firestore
            let docRef = await getUsersDoc(uid);
            //Set the uid and the user profile in the state
            commit('setLoggedInUsersUid', uid);
            commit('setUserProfile', docRef.data());

        } catch (error) {
            console.log('Error in the userProfile vuex module in the updateUserProfileDetails action');
            console.log(error);
        }
    },
    async updateSelectedBusinessProfileId({ commit, dispatch }, businessProfileId) {
        try {
            const uid = getAuth().currentUser.uid;
            //Update the selected business profile in firebase
            await updateUserDoc(uid, { businessProfileId: businessProfileId });
            //Initialize the user profile (reset the user profile, permissions and the business profile module)
            await dispatch('initializeUserProfile', uid);
        }
        catch(error) {
            console.error("Error writing document: ", error);
        };
    },
};

const mutations = {
    setUserProfileSelectedBusinessProfileId: (state, businessProfileId) => {
        state.userProfile.businessProfileId = businessProfileId;
    },
    setUserProfile: (state, userProfile) => {
        state.userProfile = userProfile;
    },
    setLoggedInUsersUid: (state, uid) => {
        state.loggedInUsersUid = uid;
    },
    setUsersPermissions: (state, loggedInUsersPermissions) => {
        state.loggedInUsersPermissions = loggedInUsersPermissions;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}
